/*
 * @Description: 
 * @Author: yuqing.hao
 * @Date: 2021-04-02 16:18:37
 * @LastEditTime: 2021-06-22 14:43:23
 * @LastEditors: zhengfan
 */
import Config from '../config';
import {getApi, postApi} from './apiUtil';
import {getToken} from '../common/session'
const { getRequestParamsStr } = require("../common/Utils");

const token = getToken();

class userApi {
	static requestUrl() {
		const url = `${Config.serverUrl}user`;
		return url;
	}

	static loadUserList(paramObj) {
		const url = `${this.requestUrl()}${getRequestParamsStr({...paramObj,token: getToken()})}`;
		return getApi(url);
	}

	static loadDepartments(paramObj) {
		const url = `${this.requestUrl()}/subgroup${getRequestParamsStr({...paramObj,token: getToken()})}`;
		return getApi(url);
	}

	static loadPersonnel(paramObj) {
		const url = `${Config.serverUrl}group/member${getRequestParamsStr({...paramObj, token: getToken()})}`;
		return getApi(url);
	}

	static loadRoughUser(){
		const url = `${this.requestUrl()}/list?token=${getToken()}`
		return getApi(url)
	}

	static setStaff(paramObj) {
		const url = `${this.requestUrl()}/staff`;
		const body = JSON.stringify({...paramObj,token:getToken()});
		return postApi(url, body);
	}

	static loadUserRecord(paramObj){
		const url = `${this.requestUrl()}/login/record${getRequestParamsStr({...paramObj,token: getToken()})}`
		return getApi(url)
	}
}

export default userApi;
